import Factory from '../utils/factory'
import Category from './category'
import Set from './set'

export default Factory({
  id: null,
  status: null,
  description: null,
  cover: null,
  pricingMethod: 'add',
  categories: [Category],
  contextualImages: [],
  sets: [Set],
})
